import { render, staticRenderFns } from "./ProductConfigurationDetail.vue?vue&type=template&id=47d28a32&scoped=true"
import script from "./ProductConfigurationDetail.vue?vue&type=script&lang=js"
export * from "./ProductConfigurationDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductConfigurationDetail.vue?vue&type=style&index=0&id=47d28a32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d28a32",
  null
  
)

export default component.exports